import {useFormContext} from "react-hook-form";
import {SERVER_VALIDATION_ERRORS} from "./CONSTANTS.ts";


export const useHasViolation = (name: string) => {
    const {formState} = useFormContext()
    const {errors} = formState

    if (errors && errors[name]) {
        //Seems we've reached the limit of what typescript can actually handle
        const violations = (errors[name]?.types as any)[SERVER_VALIDATION_ERRORS] as Array<string>
        return {hasViolation: true, violations}
    }

    return {hasViolation: false, violations: []}
}